<template>
  <div v-if="!isLoading">
    <video autoplay="autoplay" muted loop :src="this.getVideo" type="video/mp4">
      This browser does not support the video tag.
    </video>
  </div>
</template>

<script>
import axios from "axios";
import weathercodes from "./weathercodes.js";

export default {
  name: "VideoWeather",
  data() {
    return {
      isLoading: true,
      refreshTimer: null,
      weatherCode: null,
      astro: null
    };
  },
  computed: {
    getVideo() {
      if (!this.isLoading && this.weatherCode) {
        const currentCode = weathercodes.find(i => i.code === this.weatherCode);
        if (currentCode) {
          return `https://advent-sedna-weather.s3.amazonaws.com/${this.isNight()}/${
            currentCode.video_category
          }/${currentCode.video_category}.mp4`;
        }
      }
      return null;
    }
  },
  methods: {
    refreshWeather() {
      const url = "https://api.worldweatheronline.com/premium/v1/weather.ashx",
        urlQuery = new URLSearchParams(window.location.search);

      let currentLocation = "";

      if (urlQuery.get("location") !== null) {
        currentLocation = urlQuery.get("location");
      }
      axios
        .get(url, {
          params: {
            key: "eb498059c2164ed38dc123046191408",
            q: currentLocation,
            num_of_days: "1",
            format: "json",
            show_comments: "no",
            tp: "1"
          }
        })
        .then(result => {
          const currentWeather =
            result.data.data.weather[0].hourly[new Date().getHours()];
          const astronomy = result.data.data.weather[0].astronomy;
          if (currentWeather) {
            this.weatherCode = currentWeather.weatherCode;
            this.astro = astronomy;
            this.isLoading = false;
          }
        });
    },
    formatTime(time12h) {
      const [time, modifier] = time12h.split(" ");

      let [hours, minutes] = time.split(":");

      if (hours === "12") {
        hours = "00";
      }

      if (modifier === "PM") {
        hours = parseInt(hours, 10) + 12;
      }

      return `${hours}:${minutes}`;
    },
    isNight() {
      const sunset = this.formatTime(this.astro[0].sunset);
      const sunrise = this.formatTime(this.astro[0].sunrise);

      let cc = `${new Date().getHours()}:${new Date().getMinutes()}`;

      return cc >= sunrise ? (cc < sunset ? "Day" : "Night") : "Night";
    }
  },
  created() {
    window.axios = axios;
    this.refreshWeather();
    this.refreshTimer = setInterval(this.refreshWeather, 30 * 60 * 1000); // refresh news every 30 mins
  }
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
  width: 100vw;
  height: 100vh;
  /* overflow: scroll; */
}
video {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  /* transform: translateZ(0); */
}
@media screen and (max-width: 3839px) {
  body {
    width: 1920px;
    height: 1080px;
  }
}
@media screen and (min-width: 3840px) {
  body {
    width: 3840px;
    height: 2160px;
  }
}
</style>
